







































































































import Vue from 'vue';
import { mapActions } from 'vuex';

import { BRow, BCol } from 'bootstrap-vue';

import { ZenLink } from 'zenComponents';
import LoadingSpinner from '@reciprocity/loading-spinner';
import IconBox from '../box/IconBox.vue';
import listConnections from './components/listConnections.vue';
import { PATHS } from '../../../router/paths';
import { ticketingConnectionInfo } from '@/utils/crudActions';

export default Vue.extend({
  name: 'ServicenowSettings',
  components: {
    LoadingSpinner,
    listConnections,
    BRow,
    BCol,
    ZenLink,
    IconBox,
  },
  data() {
    return {
      loading: true,
      connections: [],
      PATHS,
    };
  },
  computed: {
    connected(): boolean {
      return this.connections.length > 0;
    },
  },
  async created() {
    this.loading = true;
    this.setPageTitle({ title: 'ServiceNow', visible: false });
    await this.ticketingConnectionInfo().then(data => {
      this.connections = data;
      this.loading = false;
    });
  },
  methods: {
    ticketingConnectionInfo,
    ...mapActions({
      setPageTitle: 'setPageTitle',
      showAlert: 'alerts/show',
    }),
  },
});
